import React, { useEffect, useState } from 'react';
import { Alert } from 'reactstrap';
import './Notification.scss'; // Adjust the path if necessary

// Define icon classes for different alert colors
const iconMap : any = {
  info: 'fa-circle-info',   // Example Font Awesome icon for info
  warning: 'fa-triangle-exclamation',   // Example Font Awesome icon for warning
  success: 'fa-circle-check',            // Example Font Awesome icon for success
  error: 'fa-circle-xmark',   // Example Font Awesome icon for error
};

const Notification = ({ message, position, visible, onClose, type = 'info' } : any) => {
  const [fade, setFade] = useState(false);
  useEffect(() => {
    if (visible) {
      setFade(false);
      const fadeOutTimer = setTimeout(() => {
        setFade(true);
        // Fade out duration should be less than the overall duration to ensure smooth transition
        const removeTimer = setTimeout(() => {
          onClose(); // Hide the notification after fade out
        }, 300); // Duration of the fade-out transition
        return () => clearTimeout(removeTimer);
      }, 3000); // Duration before starting fade-out
      return () => clearTimeout(fadeOutTimer);
    }
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div className={`notification ${position} ${fade ? 'fade-out' : ''}`}>
      <Alert color={type} toggle={onClose}>
        <div className="notification-content">
          <span className="notification-icon">
            <i className={`fa-regular ${iconMap[type] || 'fa-circle-info'}`}></i>
          </span>
          <span className="notification-message">
            {message}
          </span>
        </div>
      </Alert>
    </div>
  );
};

export default Notification;
